"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CommonLogic = void 0;
var uuid_1 = require("uuid");
var luxon_1 = require("luxon");
var merkle_json_1 = require("merkle-json");
var js_base64_1 = require("js-base64");
var cross_fetch_1 = __importDefault(require("cross-fetch"));
/** Not my favourite approach, but here it is */
var isNode = require('detect-node-es').isNode;
var CommonLogic = /** @class */ (function () {
    function CommonLogic() {
    }
    CommonLogic.delay = function (ms) {
        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
    };
    CommonLogic.filenameOfUrl = function (url) {
        var lastSlashPosition = url.lastIndexOf('/');
        if (lastSlashPosition === -1)
            return url;
        else
            return url.substring(lastSlashPosition + 1);
    };
    CommonLogic.folderOfFilePath = function (fullPath) {
        return CommonLogic.stringReplaceAllMatches(fullPath, [CommonLogic.filenameOfFilePath(fullPath)], '');
    };
    CommonLogic.filenameOfFilePath = function (fullPath) {
        return fullPath.replace(/^.*[\\\/]/, '');
    };
    CommonLogic.nowInsideDateTimeInterval = function (startDate, endDate) {
        var nowInMillis = CommonLogic.nowToDateTime().toMillis();
        return startDate.toMillis() <= nowInMillis && nowInMillis <= endDate.toMillis();
    };
    CommonLogic.nowToDateTime = function () {
        return luxon_1.DateTime.fromJSDate(new Date(), { zone: CommonLogic.timezone });
    };
    CommonLogic.millisToDateTime = function (millis) {
        return luxon_1.DateTime.fromMillis(millis, { zone: CommonLogic.timezone });
    };
    CommonLogic.simpleDeepClone = function (typescriptObject, excludeProperties) {
        if (excludeProperties === void 0) { excludeProperties = []; }
        if (typescriptObject === undefined)
            return undefined;
        var objectClone = CommonLogic.parseJSON(JSON.stringify(typescriptObject));
        if (excludeProperties.length > 0) {
            for (var _i = 0, _a = Object.keys(objectClone); _i < _a.length; _i++) {
                var key = _a[_i];
                if (excludeProperties.includes(key)) {
                    delete objectClone[key];
                }
            }
        }
        return objectClone;
    };
    CommonLogic.stringReplaceAllMatches = function (original, replacementMatches, newValue) {
        var cleanValue = "" + original;
        for (var _i = 0, replacementMatches_1 = replacementMatches; _i < replacementMatches_1.length; _i++) {
            var eliminate = replacementMatches_1[_i];
            do {
                cleanValue = cleanValue.replace(eliminate, newValue);
            } while (cleanValue.includes(eliminate));
        }
        return cleanValue;
    };
    CommonLogic.consistentHash = function (obj) {
        var merkleJson = new merkle_json_1.MerkleJson();
        return merkleJson.hash(obj);
    };
    CommonLogic.generateUUIDv4 = function () {
        return uuid_1.v4();
    };
    CommonLogic.removeUndefinedProperties = function (obj) {
        Object.keys(obj).forEach(function (key) { return obj[key] === undefined && delete obj[key]; });
    };
    CommonLogic.applyUndefinedProperties = function (target, source) {
        Object.keys(source).forEach(function (key) {
            if (target[key] == undefined) {
                target[key] = source[key];
            }
        });
    };
    CommonLogic.retrieveUrlContent = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var res, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, cross_fetch_1["default"](url)];
                    case 1:
                        res = _b.sent();
                        if (res.status !== 200) {
                            return [2 /*return*/, {
                                    success: false,
                                    content: null
                                }];
                        }
                        _a = {
                            success: true
                        };
                        return [4 /*yield*/, res.arrayBuffer()];
                    case 2: return [2 /*return*/, (_a.content = _b.sent(),
                            _a)];
                }
            });
        });
    };
    CommonLogic.parseJSON = function (object) {
        var reviver = function (key, value) {
            if (typeof value === 'string' && CommonLogic.pattern.test(value)) {
                return luxon_1.DateTime.fromJSDate(new Date(value));
            }
            return value;
        };
        return JSON.parse(object, reviver);
    };
    CommonLogic.encodeToBase64Binary = function (input) {
        return js_base64_1.Base64.btoa(input);
    };
    CommonLogic.decodeFromBase64Binary = function (input) {
        return js_base64_1.Base64.atob(input);
    };
    CommonLogic.stringToArrayBuffer = function (str) {
        // Default UTF-8 encoding
        if (isNode) {
            return Buffer.from(str, 'utf-8');
        }
        return new TextEncoder().encode(str);
    };
    CommonLogic.arrayBufferToString = function (input) {
        // Default UTF-8 enconding
        if (isNode) {
            return Buffer.from(input).toString('utf-8');
        }
        return new TextDecoder().decode(input);
    };
    CommonLogic.Base64 = js_base64_1.Base64;
    CommonLogic.timezone = luxon_1.FixedOffsetZone.parseSpecifier('UTC+2');
    CommonLogic.pattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}\+\d{2}:\d{2}$/;
    return CommonLogic;
}());
exports.CommonLogic = CommonLogic;
